export default "__VITE_ASSET__32f6bf08__"